import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#7800C6',
        secondary: '#FF7F00',
        accent: '#8c9eff',
        error: '#b71c1c',
        background: colors.grey.lighten4
      }
    }
  }
})
